import { render, staticRenderFns } from "./loginOld.vue?vue&type=template&id=00e71c6e&scoped=true&"
import script from "./loginOld.vue?vue&type=script&lang=js&"
export * from "./loginOld.vue?vue&type=script&lang=js&"
import style0 from "./loginOld.vue?vue&type=style&index=0&id=00e71c6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e71c6e",
  null
  
)

export default component.exports